// PHASE 4: What learning methods have you tried before?
import MultipleChoiceQuestionPage from '@app-studio-web/ui/pages/MultipleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '📱',
    title: 'pages.onboarding.pastMethods.answer1',
  },
  {
    emoji: '📚',
    title: 'pages.onboarding.pastMethods.answer2',
  },
  {
    emoji: '🎧',
    title: 'pages.onboarding.pastMethods.answer3',
  },
  {
    emoji: '👨‍🏫',
    title: 'pages.onboarding.pastMethods.answer4',
  },
  {
    emoji: '🏫',
    title: 'pages.onboarding.pastMethods.answer5',
  },
  {
    emoji: '📺',
    title: 'pages.onboarding.pastMethods.answer6',
  },
  {
    emoji: '🌐',
    title: 'pages.onboarding.pastMethods.answer7',
  },
  {
    emoji: '✨',
    title: 'pages.onboarding.pastMethods.answer8',
  },
]

export default function PastMethodsPage() {
  return (
    <MultipleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.pastMethods.title"
      subtitle="pages.onboarding.pastMethods.subtitle"
    />
  )
}
